import {labels} from '../../../util/utils';
import {LinkType} from '../../../util/uiconstants';

export const getConfig = {

	[LinkType.Share]: {
		modalTitle: labels.shareActivityModalTitle,
        modalInfo: labels.fitSharingModalInfo,
        noRequiredActivityLabel: labels.noSharedActivityInfoLabel,
        dropdownPlaceholder: labels.dropdownPlaceholderSA,
        confirmBtnTitle: labels.shareLabel,
        showDisabled: false,
        warningMessage: labels.selectActivityResponsesWarningEarlierTimeLabel,    
        documentsEngagementLabel: labels.documentsEngagementShareLabel  
	},
	[LinkType.Copy]: {
		modalTitle: labels.copyActivity,
        modalInfo: labels.fitCopyModalInfo,
        noRequiredActivityLabel: labels.noCopyActivityInfoLabel,
        dropdownPlaceholder: labels.dropdownPlaceholderCA,
        confirmBtnTitle: labels.copyLabel,
        showDisabled: true,
        warningMessage: labels.copyActivityWarningEarlierTimeLabel,
        documentsEngagementLabel: labels.documentsEngagementCopyLabel
	}
};

export function getConfiguration(linkType) {
	return linkType && getConfig[linkType];
}

